import React from "react";
import { css } from "@emotion/react";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import {
  accentColor,
  backgroundColor,
} from "main/javascripts/styles/base/colorStyle";
import { boxShadow } from "main/javascripts/styles/base/shadowStyle";

export interface IProps {
  index: number;
  position: any;
  duplicateCount?: number;
}

export const CruiseRouteListMarker: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { index, position, duplicateCount = 0 } = props;

  const left = duplicateCount > 0 ? 1 : 0;
  const markerStyles = css`
    ${markerStyle};
    left: ${left * 80}%;
  `;

  return (
    <AdvancedMarker position={position}>
      <div css={markerStyles}>{index}</div>
    </AdvancedMarker>
  );
};

const markerStyle = css`
  position: relative;
  top: 1rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${accentColor.primaryColor};
  color: ${backgroundColor.primaryLightColor};
  border-radius: 50%;
  box-shadow: ${boxShadow.interface};
  &:hover {
    background-color: ${backgroundColor.primaryDarkColor};
  }
`;
